import * as yup from 'yup'

import i18n from '../../i18n'

export const PasswordLoginInputSchema = yup.object().shape({
  password: yup.string().required(i18n.t('passwordIsMandatory', 'Password is mandatory')),
})

export type PasswordLogin = yup.Asserts<typeof PasswordLoginInputSchema>
